import { render, staticRenderFns } from "./foodlist.vue?vue&type=template&id=27d78a62&"
import script from "./foodlist.vue?vue&type=script&lang=js&"
export * from "./foodlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports